/* eslint-disable indent */
import { useState } from 'react'
import LoadingScreen from 'components/loading-screen'
import { Question, SurveyResponse } from 'contexts/survey-context/survey.interface'
import StepOne from './steps/one'
import StepTwo from './steps/two'

interface IProps {
  redirect: () => void
  title: string,
  id: number,
  questions: Question[];
  handleSubmit: (callback: () => Promise<void>) => void
  updatePolarisSurvey?: (select: SurveyResponse[][], id: number) => Promise<void>
}

const PostalCode = ({ questions, id, handleSubmit, updatePolarisSurvey, title }: IProps) => {
  const [info, setInfo] = useState({
    postalCode: '',
    neighborhoodId: null,
    state: '',
    colonia: '', // cologne?
    municipality: '',
    corrienteUrbana: null
  })

  const [step, setStep] = useState(1)

  const [answers] = useState([])

  const changeStep = (count: string = '') => {
    const newStep = count === 'increment' ? step + 1 : step - 1;
    setStep(newStep);
  }

  switch (step) {
    case 1:
      return <div className="w-full flex-1 flex flex-col"><StepOne title={title} setInfo={setInfo} info={info} changeStep={changeStep} answers={answers} question={questions[0]} /></div>;
    case 2:
      return <div className="w-full flex-1 flex flex-col"><StepTwo id={id} title={title} answers={answers} questions={questions.filter((_, index) => index !== 0)} handleSubmit={handleSubmit} updatePolarisSurvey={updatePolarisSurvey} /></div>;
    default:
      return <LoadingScreen />;
  }
}

export default PostalCode